import { getAxiosClient } from "../../axios-client";
import { GetAllWarehouseServicesGetByIdRequestBody, GetAllWarehouseServicesGetByIdResponse } from "./types";

const axiosClient = getAxiosClient();
export const getAllWarehouseServicesGetById = async (body: GetAllWarehouseServicesGetByIdRequestBody) => {
  return await axiosClient.ax.post<GetAllWarehouseServicesGetByIdResponse>(
    "Warehouses/GetAllWarehouseServicesGetById",
    body
  );
};
